import * as React from 'react';

function SvgSpringPlus8(props) {
  return (
    <svg
      width={46}
      height={315}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.925 22.743V25.367L5.081 28.611l20.104 4.116L5.08 36.844l20.102 4.116L5.08 45.075l20.102 4.115L5.08 53.307l20.104 4.116L5.08 61.539l20.102 4.117L5.08 69.77l20.102 4.116-4.258.871v4.998h5V77.13l15.844-3.244-20.104-4.116 20.104-4.117-20.104-4.116 20.104-4.115-20.104-4.115 20.104-4.116-20.104-4.117L41.77 40.96l-20.104-4.117 20.104-4.115-20.104-4.115 4.26-.872v-4.997h-5z"
        fill={props.springcolor}
      />
      <path
        d="M23.424 126.421v6.657l-10.051 6.25 20.103 12.5-20.103 12.5 20.103 12.5-20.103 12.5 20.103 12.5-20.103 12.5 20.103 12.5-20.103 12.5 20.103 12.5-20.103 12.5 20.103 12.501-10.052 6.25v6.657"
        stroke={props.springcolor}
        strokeWidth={5}
        strokeLinecap="square"
      />
      <path
        d="M34.957 0h-23v23h23V0zM34.957 292h-23v23h23v-23z"
        fill="#5BAD92"
      />
    </svg>
  );
}

export default SvgSpringPlus8;
